import React, { createContext, useCallback, useContext, useState } from 'react';

interface ImageContextType {
  processedUrls: Map<string, string>;
  processUrl: (url: string) => string;
}

const ImageContext = createContext<ImageContextType | null>(null);

export const useImageContext = () => {
  const context = useContext(ImageContext);
  if (!context) {
    throw new Error('useImageContext must be used within an ImageProvider');
  }
  return context;
};

export const ImageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [processedUrls] = useState<Map<string, string>>(() => new Map());

  const processUrl = useCallback((url: string) => {
    if (!url) return '';
    
    if (processedUrls.has(url)) {
      return processedUrls.get(url)!;
    }

    try {
      // Tenta decodificar se for uma URL codificada
      const decodedUrl = decodeURIComponent(url);
      
      // Verifica se é uma string JSON
      if (decodedUrl.startsWith('{')) {
        try {
          const jsonData = JSON.parse(decodedUrl);
          url = jsonData.imagem_url || jsonData.image_url || url;
        } catch {
          // Se falhar o parse JSON, usa a URL original
        }
      }

      // Processa a URL final
      const processedUrl = url.startsWith('http') ? url : `https://${url}`;
      processedUrls.set(url, processedUrl);
      return processedUrl;
    } catch (error) {
      console.error('Error processing image URL:', error);
      return url;
    }
  }, [processedUrls]);

  return (
    <ImageContext.Provider value={{ processedUrls, processUrl }}>
      {children}
    </ImageContext.Provider>
  );
};
